export const value = ({ textAlign = 'left', theme: { colors } }) => ({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.56,
    letterSpacing: '0.2px',
    color: colors.text,
    textAlign,
});
